'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fat';
var iconName = 'book-open-cover';
var width = 576;
var height = 512;
var aliases = ["book-open-alt"];
var unicode = 'e0c0';
var svgPathData = 'M296 86.1l46.7-16.7C382.5 55.3 424.3 48 466.5 48L528 48c17.7 0 32 14.3 32 32l0 288c0 17.7-14.3 32-32 32l-37.4 0c-62.1 0-123.3 14.5-178.9 42.2l-15.8 7.9 0-364zm-16 364l-15.8-7.9C208.7 414.5 147.4 400 85.3 400L48 400c-17.7 0-32-14.3-32-32L16 80c0-17.7 14.3-32 32-32l61.5 0c42.2 0 84 7.3 123.8 21.4l46.7 16.7 0 364zM288 72L238.6 54.4C197.2 39.6 153.5 32 109.5 32L48 32C21.5 32 0 53.5 0 80L0 368c0 26.5 21.5 48 48 48l37.3 0c59.6 0 118.4 13.9 171.7 40.5l16.6 8.3c9 4.5 19.6 4.5 28.6 0l16.6-8.3C372.2 429.9 431 416 490.6 416l37.4 0c26.5 0 48-21.5 48-48l0-288c0-26.5-21.5-48-48-48l-61.5 0c-44 0-87.7 7.6-129.2 22.4L288 72zM0 472c0 4.4 3.6 8 8 8l64 0c46.6 0 92.8 8.7 136.3 25.6l63.6 24.7c10.5 4.1 22.3 3.5 32.4-1.5l18.2-9.1C374.7 493.6 432.3 480 490.6 480l77.4 0c4.4 0 8-3.6 8-8s-3.6-8-8-8l-77.4 0c-60.9 0-120.9 14.2-175.3 41.4l-18.2 9.1c-6.1 3-13.1 3.4-19.4 .9L214 490.7C168.7 473 120.6 464 72 464L8 464c-4.4 0-8 3.6-8 8z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faBookOpenCover = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;